// Disclosure / Hedefler ad hücresi (katalog UX dalgası K5, 2026-11-03): gösterge bağlantısı + alt
// satır(lar) ("Yoğunluk paydası", birim, işletme) TEK dikey yığın, SOLA hizalı; ağaç girintisi
// yığına uygulanır (yalnız düğmeye değil). Kök neden (tarayıcıda ölçüldü): ağaç girintisi
// (`marginLeft = treeIndent`) yalnız `<button>`'daydı, alt satır `<div>`'i girintisizdi — derinlik 1'de
// ad 22 px sağda, alt satırı hücre kenarında başlıyordu; alt satırı olan satırda ad, altındaki
// metne göre sağa kayık görünüyordu. Yığın `align-items: flex-start` + `text-align: left`.

import type { ReactNode } from "react";

export function TreeLabelStack(props: {
  label: string;
  indent: number;
  onOpen: () => void;
  title: string;
  /** düğmenin hemen altındaki soluk alt satır (12 px, text-3); boşsa çizilmez */
  sub?: string | null | undefined;
  /** ek alt satırlar (ör. işletme) */
  children?: ReactNode;
}): JSX.Element {
  return (
    <div
      data-testid="kpi-tree-label"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        marginLeft: props.indent,
        minWidth: 0,
      }}
    >
      <button
        type="button"
        onClick={props.onOpen}
        title={props.title}
        style={{ color: "var(--color-primary)", textAlign: "left", minHeight: 28 }}
      >
        {props.label}
      </button>
      {props.sub ? (
        <div style={{ fontSize: 12, color: "var(--color-text-3)", textAlign: "left" }}>
          {props.sub}
        </div>
      ) : null}
      {props.children}
    </div>
  );
}
